import React from 'react';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import { userManager } from 'commons';

import Root from './components/route/Root'

const App = ({ store }) => (
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <Router>
          <Route path="/" component={Root} />
      </Router>
    </OidcProvider>
  </Provider>
);

export default App;
